import React, { Component } from 'react';
import PropTypes from 'prop-types';

import RichText from '../RichText';
import VerticalSpacing from '../Utility/VerticalSpacing/VerticalSpacing';
import Adaptive from '../Adaptive/Adaptive';
import Text from '../BuildingBlocks/Text';

class PropertyDetailContent extends Component {
  static propTypes = {
    /** Lodge/Hotel location */
    location: PropTypes.string.isRequired,
    /** Lodge/Hotel name */
    name: PropTypes.string.isRequired,
    /** String of HTML content to be sent through RichText parser */
    description: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);

    this.renderMobileLayout = this.renderMobileLayout.bind(this);
  }

  static renderRichText(richTextContent) {
    const convertedText = (
      <RichText
        whitelist={['p', 'strong']}
        converters={{
          p: {
            element: Text.CopyMini,
            props: { tagName: 'p', color: 'primary' }
          },
          strong: {
            element: Text.CopyMini,
            props: { tagName: 'span', color: 'primary', weight: 'bold', noMargins: true }
          }
        }}
        content={richTextContent}
      />
    );

    return convertedText;
  }

  render() {
    const { location, name, description } = this.props;

    return (
      <VerticalSpacing size="sm">
        <Text.HeadingFifth tagName="h2" color="quaternary" textTransform="uppercase">
          {location}
        </Text.HeadingFifth>
        <Text.HeadingThird tagName="h1">{name}</Text.HeadingThird>

        <Adaptive lg={PropertyDetailContent.renderRichText(description)} />
      </VerticalSpacing>
    );
  }
}

export default PropertyDetailContent;
